export default {
  app: {
    guestUser: '访客用户',
    tapViewProfile: '点击查看个人资料',
    tapSignIn: '点击登录',
    browse: '浏览',
    account: '账户',
    home: '首页',
    discover: '发现房源',
    addPlace: '添加地点',
    myProfile: '我的资料',
    signOut: '退出登录',
    signIn: '登录',
    login: '登录',
    footer: '找到适合你的学生住房',
    searchPlaceholder: '搜索住房、宿舍...',
    language: '语言'
  },
  reviews: {
    title: '{count} 条学生评价',
    searchPlaceholder: '按关键词、评价人、学校搜索评价...',
    allRooms: '全部房间',
    selectedRoom: '已选房间',
    latest: '最新',
    earliest: '最早',
    highestRated: '评分最高',
    lowestRated: '评分最低',
    priceHighLow: '价格从高到低',
    priceLowHigh: '价格从低到高',
    noSearchResults: '没有找到包含"{query}"的评价。请换个关键词试试。',
    anonymous: '匿名用户',
    edit: '编辑',
    delete: '删除',
    viewDetails: '查看详情',
    yourself: '你自己',
    recommended: '推荐',
    deposit: '押金',
    flatmate: '位室友',
    flatmates: '位室友',
    billsIncluded: '包含账单',
    sharedBath: '共用浴室',
    privateBath: '独立浴室',
    biggestIssue: '最大问题：',
    noContent: '暂无评价内容。',
    helpful: '有帮助吗？',
    comments: '评论',
    leaveComment: '写下你的评论...',
    submit: '提交'
  },
  translation: {
    seeOriginal: '查看原文',
    seeTranslation: '查看翻译',
    translating: '翻译中...'
  },
  auth: {
    loginRequiredTitle: '请先登录',
    loginRequiredText: '你需要登录账号，才能在 Sparrow 分享或编辑评价。',
    loginRequiredConfirm: '登录',
    loginRequiredCancel: '暂不',
    adminOnlyTitle: '仅限管理员',
    adminOnlyText: '此页面仅对 Sparrow 管理员开放。'
  },
  home: {
    searchLabel: '你想找什么？',
    seeMore: '查看更多',
    trustedBy: '受到学生信赖',
    perfectHomeLine1: '找到你的理想',
    perfectHomeLine2: '学生住所',
    realReviews: '真实评价，真实评分，真实社区。',
    businessSubtitle: '想要拓展业务？',
    businessTitle: '通过 Sparrow 上的评价提升你的声誉',
    getStarted: '开始使用',
    popularListings: '热门房源',
    topRatedHousing: '评分最高的住房',
    noPopularListings: '暂无热门房源。',
    partnerTitle: '与 Sparrow 合作',
    partnerSubtitle: '与成千上万寻找优质住房的学生建立联系。',
    fullName: '姓名',
    workEmail: '工作邮箱',
    keepUpdated: '及时获取 Sparrow 最新动态',
    submitRequest: '提交申请',
    helpMillions: '帮助数百万人做出正确选择',
    shareExperience: '在 Sparrow 分享你的经验，让评价带来改变。',
    loginOrSignUp: '登录或注册',
    recentReviews: '最新评价',
    noRecentReviews: '暂无最新评价。',
    beFirstReview: '成为第一个分享经验的人！',
    rewardTitlePrefix: '赢取',
    rewardTitleSuffix: '星巴克电子礼品卡',
    rewardLeadPrefix: '前',
    rewardLeadSuffix: '份符合条件的内容：发布经过验证的房源评价，完成检查清单，审批后奖励说明将发送至你的账户邮箱。',
    loadingProgress: '加载进度中...',
    roundFull: '名额已满',
    campaignStatsError: '无法加载活动数据，请稍后再试。',
    showLess: '收起',
    viewMore: '了解更多',
    howItWorks: '如何参与',
    rewardStep1: '在 Sparrow 上发布带照片和文字叙述的房源评价。',
    rewardStep2: '完成检查清单：至少上传照片并对其他房源发表实质性评论。',
    rewardStep3: '提交审核；审核通过后奖励说明将发送到你的账户邮箱。',
    rewardFoot: '你的个人资料显示与审核团队使用的检查清单进度一致。',
    rewardsClaimed: '已领取 {approved} / {limit} 份奖励',
    openProfileChecklist: '打开个人资料检查清单',
    signInToParticipate: '登录参与',
    footerTagline: '值得信赖的学生住房声音。',
    platform: '平台',
    features: '功能',
    community: '社区',
    support: '支持',
    company: '公司',
    aboutUs: '关于我们',
    contactUs: '联系我们',
    terms: '服务条款',
    privacy: '隐私政策',
    stayUpdated: '获取最新动态',
    subscribeText: '订阅 Sparrow 最新资讯',
    filters: {
      all: '全部',
      companies: '公司',
      universities: '大学'
    },
    categories: {
      dorms: '宿舍',
      apartments: '公寓',
      sublets: '转租',
      roommates: '室友',
      companies: '公司',
      universities: '大学',
      studios: '单间',
      shared: '合租'
    },
    heroCards: {
      trusted: {
        title: '找到值得信赖的学生住房',
        subtitle: '发现、阅读和撰写你的学生故事'
      },
      nest: {
        title: '找到你的理想居所',
        subtitle: '真实学生的真实评价，不再有隐藏的惊喜。'
      }
    },
    featureCards: {
      anonymous: {
        title: '匿名评价',
        text: '在不透露身份的情况下，分享你对住所的真实体验。'
      },
      rating: {
        title: '住房评分',
        text: '为每个宿舍贡献综合评分，反映所有人的反馈。'
      },
      verified: {
        title: '大学验证',
        text: '仅限大学邮箱用户注册，确保可信赖的空间。'
      },
      community: {
        title: '社区论坛',
        text: '与其他学生交流，分享建议、提问和寻求帮助。'
      }
    }
  },
  pages: {
      AddHouse: {
        add_a_house_91f72fd: '添加房屋',
        add_a_new_room_3b3d65d: '添加新房间',
        add_a_room_adce167: '+ 添加房间',
        add_a_room_caf6776: '添加房间',
        address_information_477f95d: '地址信息',
        address_no_24637ab: '地址编号',
        agency_5c47e26: '中介',
        and_8278d2a: '和',
        area_2745deb: '区域',
        by_continuing_i_confirm_that_i_hav_9d12334: '继续即表示我已阅读并同意Sparrow的',
        cancel_77dfd21: '取消',
        community_guidelines_7534366: '社区指南',
        continue_2e02623: '继续',
        continue_ff3dbb4: '继续',
        district_c0cb139: '区',
        drag_the_pin_on_the_map_below_if_t_a574c10: '如果标记不在正确的建筑物上，请拖动下面的图钉。',
        e_g_98_dbfc94f: '例如：98',
        e_g_clear_water_bay_rd_56f3f57: '例如：清水湾道。',
        e_g_gf_1f_718c4f7: '例如：GF，1楼',
        e_g_hkust_accommodation_office_sun_58b5597: '例如：香港科技大学宿舍办公室 / 阳光代理',
        e_g_room_a_b_unit_c_3cf8567: '例如：A室，B室 / 单元C',
        e_g_tai_po_tsai_village_625e661: '例如：大埔蔡村',
        filled_in_from_the_selected_addres_a19ab88: '已根据所选地址自动填写，您仍可自行编辑。',
        location_type_58cd45f: '位置类型',
        managed_by_name_4763975: '管理名称',
        managed_by_type_12a4cac: '管理类型',
        none_of_these_is_mine_create_new_h_c1b0e04: '这些都不是我的 — 创建新房屋',
        off_campus_de6195e: '校外',
        on_campus_ee963a7: '校内',
        pin_exact_location_for_the_map_d58635d: '固定精确位置（用于地图）',
        pinned_d14f89f: '📍 已固定：',
        privacy_policy_9db108b: '隐私政策',
        private_landlord_e5b909a: '私人房东',
        region_0f21717: '地区',
        save_property_only_055ca3f: '仅保存物业',
        search_for_existing_house_9740309: '搜索现有房屋',
        searching_1a6a5ba: '搜索中…',
        select_area_8f1f4cc: '选择区域',
        select_district_666f30d: '选择区域',
        select_location_type_710db92: '选择位置类型',
        select_managed_by_type_8832a1e: '选择管理类型',
        select_region_570539e: '选择地区',
        share_a_new_student_housing_locati_03e69d1: '与社区分享新的学生住宿地点',
        street_b454109: '街道',
        terms_of_use_9773841: '使用条款',
        type_a_real_address_e_g_clear_wate_29ecd02: '按大厦或屋苑名称搜索，例如：新都城第一期',
        type_to_find_your_room_6bba2e8: '输入以查找您的房间',
        type_to_search_address_or_place_na_a379ebd: '输入以搜索地址或地点名称…'
      },
      AddHouseRoom: {
        add_a_new_room_349da31: '添加新房间',
        e_g_g_f_1_f_5455941: '例如 G/F, 1/F',
        e_g_rooma_roomb_a3f6e21: '例如 RoomA, RoomB',
        floor_7db82f7: '楼层',
        got_it_5b8027f: '知道了',
        input_manually_726a1dd: '✍️手动输入',
        input_manually_new_floor_new_room_e2870be: '✍️手动输入（新楼层/新房间）',
        property_9ae33a7: '房源',
        property_type_ad794a4: '物业类型',
        room_90e2fca: '房间',
        room_information_48daf6c: '房间信息',
        search_for_existing_room_fef943d: '搜索现有房间',
        try_finding_the_room_if_it_isn_t_l_df482ef: '尝试查找房间。如果未列出，请点击下方的“手动输入”以添加新楼层或单元。',
        type_to_find_your_room_ee10746: '输入以找到您的房间…'
      },
      AdminLocations: {
        admin_house_locations_11562f6: '管理员 · 房屋位置',
        drag_any_pin_to_correct_its_locati_46eadc8: '拖动任何图钉以纠正其位置。立即保存。尚未有图钉的房屋出现在左侧列表中 — 点击一个将其放置在可见地图中心。',
        filter_by_name_district_area_manag_fd68d57: '按名称、地区、区域、经理等筛选…',
        no_matches_0be6a25: '无匹配项。',
        no_pin_8d7ac9d: '无图钉',
        saving_56a2285: '正在保存…'
      },
      Log_Reg: {
        already_have_an_account_8559034: '已有账户？',
        back_to_sign_up_8927212: '← 返回注册',
        create_account_eff4fd8: '创建账户',
        domain_not_supported_ef85cbc: '域名不支持',
        don_t_have_an_account_f838dc1: '没有账户？',
        enter_your_personal_details_and_st_26cd777: '输入您的个人信息，开始与我们的旅程',
        forgot_password_4c29f7f: '忘记密码？',
        full_name_64346b4: '姓名',
        hello_friend_c896fbc: '你好，朋友！',
        hello_friend_enter_your_personal_d_faf18f4: '你好，朋友！输入您的个人信息，开始与我们的旅程。',
        note_optional_4e39567: '备注（可选）',
        password_8be3c94: '密码',
        sign_in_f8492cc: '登录',
        sign_in_to_continue_to_your_accoun_791f0bb: '登录以继续您的账户',
        sign_up_2ba4023: '注册',
        slide_to_verify_68b61e8: '滑动验证',
        the_email_you_entered_9680274: '您输入的电子邮件',
        to_keep_connected_with_us_please_l_a7f6a8b: '为了保持与我们的联系，请使用您的个人信息登录',
        try_again_042c862: '重试',
        university_email_2d10f47: '大学邮箱',
        university_name_eb33cf0: '大学名称',
        use_your_hong_kong_university_emai_9179d02: '使用你的香港大学邮箱加入',
        verified_f6cc6a5: '验证成功！',
        verify_dda6ac2: '验证',
        welcome_back_1c90894: '欢迎回来',
        welcome_back_7927e5d: '欢迎回来！',
        welcome_back_to_keep_connected_wit_235aae1: '欢迎回来！为了保持与我们的联系，请使用您的个人信息登录。',
        your_university_is_not_yet_on_spar_31e8c27: '您的大学尚未加入Sparrow。以下请求访问权限。',
        agree_terms_prefix_fd9c616: '我同意 Sparrow 的',
        terms_of_use_link_3e81a3c: '服务条款',
        agree_terms_middle_66e6680: '，并知悉',
        privacy_policy_link_c3fe6d6: '隐私政策',
        agree_terms_and2_e1f9f9e: '及',
        pics_link_f2a31b8: '个人资料收集声明',
        agree_account_personal_b66aa09: '我理解我的学生账户仅供本人使用，不得代表房东、运营方、大学宿舍办公室、中介或其他住房提供方共享或使用。',
        agreement_required_title_f81748c: '需要同意条款',
        agreement_required_text_14d1733: '请先同意服务条款和隐私政策，并确认账户仅供本人使用，然后再注册。'
      },
      PrivacyPolicy: {
        title_e71f479: '隐私政策',
        subtitle_ec63f07: 'Sparrow 如何收集、使用、分享和保护您的个人数据'
      },
      TermsOfUse: {
        title_b345ab3: '服务条款',
        subtitle_205f278: '适用于访问和使用 Sparrow 平台的规则'
      },
      rateTheHouse: {
        before_you_submit_title_7f3a1c2: '提交前确认',
        consent_honest_label_4d8e2b1: '本评价基于我的亲身经历，据我所知真实准确。',
        consent_identity_label_9c1f6a3: '我理解 Sparrow 不会显示我的姓名或大学邮箱，但熟悉该房间或相关情况的人仍可能推断出我的身份。',
        consent_provider_share_label_2b7d5e4: '我理解 Sparrow 可能会向相关住房提供方提供经过筛选、脱敏、改写、针对具体房间或汇总处理的评价内容，但通常不会提供我的姓名、邮箱或其他私人账户信息。',
        consent_photo_rights_prefix_6a4f9d0: '这些照片由我拍摄，或我已获得分享许可，我同意授予 Sparrow ',
        consent_photo_rights_link_3e8c1b5: '《服务条款》',
        consent_photo_rights_suffix_1d9a7c6: '中所述的权利。',
        consent_photo_no_private_label_8f2b3a1: '这些照片不包含可识别的人物、个人证件、姓名、联系方式、门禁密码、钥匙、安防信息或其他隐私信息。',
        consent_required_review_text_5c6d8e2: '提交评价前，请勾选全部三项评价同意声明。',
        consent_required_photo_text_9b3f1a4: '由于您已上传照片，提交前请勾选全部两项照片同意声明。'
      },
      recommendHouse: {
        '1_bed_fb8e3a4': '1床',
        '2_beds_435bff3': '+2床',
        add_a_review_now_c2a5684: '现在添加评论 →',
        add_to_multi_location_search_e76d666: '添加到多位置搜索',
        all_6a72085: '全部',
        any_322444d: '不限',
        apply_cfea419: '应用',
        apply_filter_aa3dea2: '应用筛选',
        avg_price_ec4ddd4: '平均价格：',
        bathrooms_2a0b1c2: '浴室',
        bedroom_f69fecd: '床位',
        bunk_bed_3de27ba: '双层床',
        clear_719ea39: '清除',
        clear_all_c043160: '清除所有',
        close_filters_c2db1e0: '关闭筛选',
        details_dc3decb: '详情',
        filters_96e5782: '筛选',
        filters_map_c2ffed9: '筛选和地图',
        it_is_not_what_you_are_looking_for_6b7739a: '这不是你要找的吗？',
        likes_ea70b16: '点赞：',
        max_a95e85a: '最大',
        max_floor_5363671: '最大楼层',
        max_price_de84944: '最高价格',
        max_roommates_27e71b8: '最多室友',
        min_7eb0cee: '最小',
        min_floor_7336b36: '最小楼层',
        min_price_f9cc312: '最低价格',
        min_roommates_bfeb7ec: '最少室友',
        my_location_fba0847: '我的位置',
        off_campus_6fd4374: '校外',
        on_campus_de78303: '校内',
        personal_40f0732: '独立',
        please_select_the_area_you_are_sea_82558be: '请选择您要搜索的区域，我们将推荐该区域的房产。',
        price_range_42363d0: '价格范围',
        provider_7ceee3f: '提供方',
        provider_f60f814: '提供商：',
        remove_location_d805001: '移除位置',
        reset_44c57ab: '重置',
        results_612e12d: '结果',
        reviews_17f8ebd: '评价：',
        room_type_6320f14: '房间类型',
        rooms_and_beds_1fc6dd7: '房间和床',
        scanning_the_network_for_homes_5c93823: '正在扫描网络中的房屋...',
        search_bce0641: '搜索',
        search_houses_dorms_locations_248bdb2: '搜索房屋、宿舍、地点...',
        select_a_university_80d42c5: '选择一所大学…',
        select_location_9fa73f5: '选择位置',
        shared_50d0d8d: '共用',
        show_places_9daa640: '显示地点',
        sort_by_9bb640e: '排序：',
        wait_for_others_to_share_their_exp_cafd50a: '等待其他人分享他们的经验或'
      },
      rewardAdmin: {
        admin_4e7afeb: '管理员',
        admin_note_4193c1a: '管理员备注',
        admin_sections_80deff5: '管理员部分',
        admin_system_e07b109: '管理员系统',
        analytics_25bc962: '分析',
        approve_7b2c7f1: '批准',
        approved_slots_af4ed8a: '批准的时段',
        comments_fce06e2: '评论',
        decision_7f59a1f: '决定',
        eligible_comments_bcd45f2: '符合条件的评论',
        email_a_z_05d6a57: '邮箱（A–Z）',
        email_this_student_about_the_hk_50_ebb8505: '关于HK$50星巴克奖励给这位学生的邮件。信息包括他们的实时清单（评价、照片、评论）以及他们的个人资料链接。',
        flags_5d72875: '标志',
        incomplete_387fd1b: '不完整',
        loading_submission_b0d8c6c: '正在加载提交…',
        mark_issued_ddacea2: '标记已发放',
        most_recent_activity_e73e4ff: '最近的活动',
        name_a_z_c93e4c5: '名称（A–Z）',
        no_comments_found_for_this_user_e19abb6: '未找到此用户的评论。',
        no_submissions_yet_users_appear_he_b87ec6d: '尚未提交。当用户在第一个50个奖励上取得进展时，用户将出现在此处。',
        not_started_db2c45d: '未开始',
        optional_note_for_the_user_or_inte_f8e6661: '可选的用户或内部日志备注',
        optional_personal_note_from_you_sh_a0cf2a2: '可选的个人备注（将在邮件中显示）',
        order_1d75774: '订单',
        own_listing_9aeb139: '自己的列表',
        photos_c8b2e86: '照片',
        progress_reminder_email_0834ecf: '进度提醒邮件',
        refresh_queue_50c3cf3: '刷新队列',
        reject_2b03b59: '拒绝',
        reminders_are_only_available_for_s_15dd308: '提醒仅适用于尚未开始或仍在进行中的学生（未待验证、批准或发放）。',
        repetitive_3ffacb5: '重复的',
        review_evidence_ab34d96: '审查证据',
        reward_approvals_and_aggregated_us_21b1cbc: '奖励批准和汇总使用指标。',
        reward_queue_2e39291: '奖励队列',
        select_a_submission_from_the_list__c02db7e: '从列表中选择一个提交以审查证据并做出决定。',
        status_workflow_bbc54ed: '状态（工作流程）',
        too_short_b126726: '太短',
        updating_3ab0d73: '正在更新…',
        url_is_not_allowed_http_https_only_274bdb6: '不允许URL（仅限http/https）',
        view_on_site_b66ea87: '在网站上查看 ↗'
      },
      showReview: {
        be_the_first_to_comment_dc12124: '成为第一个评论者',
        bed_type_f5d7e43: '🛏️ 床型',
        biggest_problem_46e04d0: '⚠️ 最大问题',
        bills_included_e196739: '📋 包含账单',
        cleanliness_condition_c3040e5: '清洁度与状况',
        comment_153d7a5: '评论',
        content_2459603: '内容：',
        cost_transparency_07c6382: '成本透明度',
        delete_9485989: '删除',
        deposit_82da2bf: '🔑 押金',
        edit_9ead47a: '编辑',
        helpful_02f9858: '有帮助吗？',
        images_09e871c: '图片',
        internet_utilities_reliability_6886085: '互联网与公共事业可靠性',
        leave_a_comment_5a91cc8: '留下评论',
        listing_accuracy_a4530e1: '列表准确性',
        living_comfort_3754e95: '舒适生活',
        loading_review_a539d74: '加载评论中…',
        location_convenience_b5ea55e: '位置便利性',
        maintenance_responsiveness_2cf7ad6: '维护响应速度',
        monthly_rent_4a0531d: '💰 月租金',
        no_image_33cf70a: '无图片',
        noise_exposure_9c76355: '噪音暴露',
        recommended_7a9fe3e: '👍 推荐？',
        review_not_found_49fa790: '评论未找到。',
        room_type_763a5f9: '🏠 房间类型',
        roommates_be61f72: '👥 室友',
        safety_db6e7e4: '安全',
        shared_bathroom_4d9173c: '🚿 共用浴室',
        space_adequacy_1631412: '空间充足度',
        stay_duration_6919b3d: '📅 停留时长',
        submit_review_c191880: '提交评价',
        user_3123a0e: '用户：',
        write_your_review_here_26c1eea: '在这里写下您的评论...',
        yourself_803037d: '自己'
      },
      userInfo: {
        academic_year_5f1566b: '学年：',
        account_credentials_481ad68: '账户凭证',
        choose_avatar_98122fb: '选择头像',
        current_password_4d59678: '当前密码',
        email_84add5b: '邮箱',
        enter_6_digit_code_4c9c785: '输入6位数字代码',
        enter_your_current_password_9149cfc: '输入您的当前密码',
        enter_your_new_password_7bec90c: '输入您的新密码',
        female_b7c17e9: '女',
        gender_8a754c6: '性别',
        male_3f3a489: '男',
        manage_your_profile_settings_updat_6a6cb13: '管理您的个人资料设置，更新您的凭证并自定义您的偏好。',
        new_password_4894cb3: '新密码',
        other_6e6a6f2: '其他',
        profile_settings_df4b081: '个人资料设置',
        save_profile_changes_24dcd52: '保存个人资料更改',
        send_code_f687607: '发送代码',
        university_715432d: '大学',
        update_credentials_f749a73: '更新凭证',
        username_84c2901: '用户名',
        verification_code_50cdc18: '验证码'
      },
      userProfile: {
        '50_for_50_starbucks_review_giveawa_9329564': '50换50 – 星巴克评论赠品',
        all_reward_spots_are_filled_for_th_adb6f04: '本轮所有奖励名额已满。',
        bio_b31fc96: '个人简介',
        budget_7aeba4c: '预算',
        edit_profile_cd280a4: '编辑个人资料',
        email_verified_9d240e9: '邮箱验证',
        housing_preferences_45c40e9: '住房偏好',
        id_verified_3e759b1: '身份验证',
        loading_33ce417: '加载中…',
        logout_e43d612: '登出',
        near_campus_ef995c6: '靠近校园',
        open_review_b085791: '开启评论',
        qualifying_listing_one_reward_007a62d: '合格列表（一个奖励）',
        starbucks_review_giveaway_requirem_deb6ec8: '星巴克评论赠品要求',
        washer_dryer_wi_fi_cb5014d: '洗衣机/烘干机，Wi-Fi',
        written_detail_fc01c38: '文字详情'
      }
  },
  emptyState: {
    notReviewedYet: '暂无评价'
  },
  legal: {
    backToApp_23fdde0: '返回 Sparrow',
    breadcrumbHome_996be5e: '首页',
    onThisPage_993081e: '本页导航'
  }
};
